(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nad-restores"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviveTabs(root) {
      var tabs   = root.querySelectorAll('.revive-tabs__tab');
      var panels = root.querySelectorAll('.revive-tabs__panel');
      if (!tabs.length || !panels.length) return;

      function activate(index, focusTab) {
        tabs.forEach(function (tab, i) {
          var isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          if (isActive && focusTab) tab.focus();
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        var target = panels[index];
        if (target) {
          void target.offsetWidth;
          target.classList.add('is-active');
          animateScienceBars(target);
          var carousel = target.querySelector('[data-formulation-id]');
          if (carousel) updateCarouselDisplay(carousel);
        }
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(index, false); });

        tab.addEventListener('keydown', function (e) {
          var key  = e.key;
          var last = tabs.length - 1;
          var next = index;

          if (key === 'ArrowDown' || key === 'ArrowRight')       next = index === last ? 0 : index + 1;
          else if (key === 'ArrowUp' || key === 'ArrowLeft')     next = index === 0 ? last : index - 1;
          else if (key === 'Home')                               next = 0;
          else if (key === 'End')                                next = last;
          else return;

          e.preventDefault();
          activate(next, true);
        });
      });

      var initialActive = root.querySelector('.revive-tabs__panel.is-active');
      if (initialActive) {
        animateScienceBars(initialActive);
        var carousel = initialActive.querySelector('[data-formulation-id]');
        if (carousel) updateCarouselDisplay(carousel);
      }
    }

    function animateScienceBars(panel) {
      panel.querySelectorAll('.revive-science__stat').forEach(function (stat) {
        var pct  = parseFloat(stat.getAttribute('data-pct')) || 0;
        var fill = stat.querySelector('.revive-science__bar-fill');
        if (!fill) return;
        fill.style.width = '0%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.style.width = pct + '%';
          });
        });
      });
    }

    function initFormulationCarousel(wrapper) {
      var slides = Array.from(wrapper.querySelectorAll('.revive-formulation__slide'));
      var infos  = Array.from(wrapper.querySelectorAll('.revive-formulation__info'));
      var prevBtn = wrapper.querySelector('[data-prev]');
      var nextBtn = wrapper.querySelector('[data-next]');
      if (!slides.length) return;

      var current = 0;
      var total   = slides.length;

      function goTo(index) {
        current = (index + total) % total;
        slides.forEach(function (s) { s.classList.remove('is-active', 'is-prev', 'is-next'); });
        infos.forEach(function (inf) { inf.classList.remove('is-active'); });
        slides[current].classList.add('is-active');
        if (infos[current]) infos[current].classList.add('is-active');
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      goTo(0);
      return { goTo: goTo };
    }

    function updateCarouselDisplay(wrapper) {
      var slides = wrapper.querySelectorAll('.revive-formulation__slide');
      if (!slides.length) return;
      var hasActive = wrapper.querySelector('.revive-formulation__slide.is-active');
      if (!hasActive) initFormulationCarousel(wrapper);
    }

    function initAll() {
      document.querySelectorAll('.revive-tabs').forEach(function (root) {
        initReviveTabs(root);
        root.querySelectorAll('[data-formulation-id]').forEach(function (wrapper) {
          initFormulationCarousel(wrapper);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.revive-tabs');
      if (section) {
        initReviveTabs(section);
        section.querySelectorAll('[data-formulation-id]').forEach(initFormulationCarousel);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["time-release"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initVideoSection(wrap) {
      var video = wrap.querySelector('video[data-autoplay]');
      if (!video) return;
      if (wrap.dataset.videoInit) return;
      wrap.dataset.videoInit = 'true';

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();

            video.preload = 'auto';
            video.load();

            function tryPlay() {
              video.play()
                .then(function () {
                  wrap.classList.add('video-playing');
                })
                .catch(function () {});
            }

            if (video.readyState >= 3) {
              tryPlay();
              return;
            }

            var played = false;
            function onReady() {
              if (played) return;
              played = true;
              video.removeEventListener('canplay', onReady);
              video.removeEventListener('canplaythrough', onReady);
              tryPlay();
            }

            video.addEventListener('canplay', onReady);
            video.addEventListener('canplaythrough', onReady);

            setTimeout(function () {
              if (!played) {
                played = true;
                video.removeEventListener('canplay', onReady);
                video.removeEventListener('canplaythrough', onReady);
                tryPlay();
              }
            }, 3000);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
      );

      observer.observe(wrap);
    }

    function init() {
      var sections = document.querySelectorAll('[data-video-section]');
      sections.forEach(initVideoSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
